import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  errorNotificationTitle: {
    description: 'pickup location error notification title',
    defaultMessage: 'Failed to Ship From Contacts',
    id: 'm0nc2P',
  },
  errorNotificationMessage: {
    description: 'pickup location error notification message',
    defaultMessage: 'An unexpected error occurred while loading contacts.',
    id: 'kBbL3d',
  },
  pickupLocationLabel: {
    defaultMessage: 'Pickup Location',
    description: 'pickupLocation.pickupLocation',
    id: 'hIZWHP',
  },
  pickupLocationContactLabel: {
    defaultMessage: 'Pickup Contact',
    description: 'pickupLocation.pickupContact',
    id: 'JN+jjU',
  },
  pickupLocationAddressLabel: {
    defaultMessage: 'Address',
    id: '2gin0Y',
    description: 'Pickup Location address label',
  },
});
